const language = {
    en: {
        navbar: {
            create: "Create Station",
            more:
                "Learn more about our project",
            overview: "Map",
            validation: "Validation",
            statistics: "Statistics",
            ebsw: "EBSW",
            ownStations: "My Stations",
            login: "Log in",
            logout: "Log out",
            searchLabel: "Find a station",
            searchPlaceholder: "Search stations...",
            searchNoResults: "No stations match your search.",
            searchLoading: "Loading stations...",
            searchError: "We couldn't load the stations."
        },

        map: {
            stationName: "Name of the station: ",
            inspect: "Inspect station",
            lastEnvironment: "Last measurement: ",
            lastMovement: "Last bird: ",
            statistics: "Show statistics",
            lastFeedStatus: "Last feed status: ",
            level: "Silo level: "
        },
        login: {
            title: "Welcome back",
            subtitle: "Sign in to manage your stations and alerts.",
            email: "Email",
            password: "Password",
            submit: "Log in",
            error: "We couldn't sign you in. Double-check your credentials.",
            backToMap: "Back to the map",
            registerPrompt: "Need an account?",
            registerLink: "Create one now",
            forgotPrompt: "Forgot your password?",
            forgotLink: "Reset it",
            verifyPrompt: "Already registered but still locked out?",
            verifyLink: "Verify your email"
        },
        register: {
            title: "Create your account",
            subtitle: "Sign up to manage your bird stations and notifications.",
            name: "Display name (optional)",
            email: "Email",
            password: "Password",
            confirmPassword: "Confirm password",
            submit: "Register",
            success: "Account created successfully.",
            error: "We couldn't create your account.",
            passwordMismatch: "Passwords do not match.",
            backToLogin: "Back to login",
            backToMap: "Back to the map"
        },
        passwordReset: {
            title: "Reset your password",
            requestSubtitle: "Send a secure reset link to your inbox in one step.",
            confirmSubtitle: "Paste the token from your email and set a new password.",
            requestTab: "Request link",
            confirmTab: "Set new password",
            emailLabel: "Email",
            tokenLabel: "Reset token",
            newPasswordLabel: "New password",
            requestSubmit: "Send reset email",
            confirmSubmit: "Update password",
            requestSuccess: "If an account exists for that email, we just sent reset instructions.",
            confirmSuccess: "Password updated. Redirecting you to your stations...",
            requestError: "We couldn't process that email right now.",
            confirmError: "We couldn't reset your password with that token.",
            verificationRequired: "Please verify your email before resetting your password. Redirecting you...",
            backToLogin: "Back to login",
            backToMap: "Back to the map"
        },
        verifyEmail: {
            title: "Verify your email",
            verifySubtitle: "Paste the token from your verification email to activate your account.",
            resendSubtitle: "Need a new message? Resend the verification email below.",
            verifyTab: "Verify email",
            resendTab: "Resend email",
            tokenLabel: "Verification token",
            emailLabel: "Email",
            verifySubmit: "Verify email",
            resendSubmit: "Send email",
            verifySuccess: "Email verified. Redirecting you to your stations...",
            resendSuccess: "If the account is unverified, a new email is on the way.",
            verifyError: "We couldn't verify that token.",
            resendError: "We couldn't send a new verification email.",
            backToLogin: "Back to login",
            backToMap: "Back to the map"
        },
        ownStations: {
            title: "My Stations",
            subtitle: "Rename, review, or remove the stations linked to your account.",
            refresh: "Refresh",
            loading: "Loading your stations...",
            loadError: "We couldn't load your stations right now.",
            empty: "No stations are linked to your account yet.",
            createCta: "Create a station",
            viewStation: "Open station view",
            deleteStation: "Delete station",
            deleteConfirm: "Delete station {name}? All recordings will be removed.",
            deleteSuccess: "Station deleted.",
            deleteError: "Unable to delete the station.",
            stationKey: "Station key",
            copyKey: "Copy",
            keyCopied: "Station key copied to clipboard.",
            keyCopyError: "Unable to copy the key. Please copy it manually.",
            nameLabel: "Station name",
            descriptionLabel: "Station description",
            descriptionHelper: "Describe how your station is built and set up. This is shown publicly on the station page.",
            locationLat: "Latitude",
            locationLng: "Longitude",
            mailAddresses: "Notification emails",
            mailHelper: "Separate multiple addresses with commas",
            mailNotifications: "Send notifications",
            senseboxLabel: "senseBox ID",
            softwareLabel: "Station software",
            softwareOptions: {
                birdiary: "Birdiary",
                duisbird: "DuisBird"
            },
            typeLabel: "Station type",
            advancedSettings: "Advanced settings (JSON)",
            advancedSettingsHelper: "Include exhibit/test options or custom overrides as JSON.",
            saveStation: "Save station",
            saveSuccess: "Station updated.",
            saveError: "Unable to update the station.",
            invalidLocation: "Latitude and longitude must be valid numbers.",
            invalidAdvancedSettings: "Advanced settings must be valid JSON.",
            types: {
                observer: "Observer",
                test: "Test",
                exhibit: "Exhibit"
            },
            movements: "Latest movements",
            movementDate: "Captured",
            movementSpecies: "Species",
            noSpecies: "No detection recorded",
            loadMoreMovements: "Load more movements",
            loadAllMovements: "Load all movements",
            loadingMovements: "Loading movements...",
            allMovementsLoaded: "All movements are visible.",
            deleteMovement: "Delete",
            deleteMovementConfirm: "Delete this movement? The video and audio will be removed.",
            deleteMovementSuccess: "Movement deleted.",
            deleteMovementError: "Unable to delete the movement.",
            noMovements: "No movements recorded yet.",
            logbookTitle: "Logbook (private)",
            logbookHelper: "Only you and admins can see these entries. Use it to keep notes about maintenance, sightings, or changes to your station over time.",
            logbookEmpty: "No logbook entries yet.",
            logbookAddLabel: "New logbook entry",
            logbookAddSubmit: "Add entry",
            logbookAddError: "Unable to add the logbook entry.",
            logbookDeleteEntry: "Delete",
            logbookDeleteError: "Unable to delete the logbook entry.",
            passwordTitle: "Password & security",
            currentPassword: "Current password",
            newPassword: "New password",
            passwordAction: "Update password",
            passwordSuccess: "Password updated successfully.",
            passwordError: "Unable to update the password.",
            emailStatusVerified: "Your email address is verified.",
            emailStatusPending: "Your email address still needs verification.",
            resendVerification: "Resend verification email",
            resendVerificationSending: "Sending verification email...",
            resendVerificationSuccess: "If the account is unverified, a new email is on the way.",
            resendVerificationError: "We couldn't send a new verification email right now.",
            claimTitle: "Claim an existing station",
            claimSubtitle: "Link a station you created earlier by providing its ID.",
            claimStationId: "Station ID",
            claimAction: "Link station to my account",
            claimSuccess: "Station linked to your account.",
            claimError: "We couldn't link that station. Check the ID and try again.",
            claimMissingFields: "Please enter a station ID.",
            ownerLabel: "Owner",
            ownerNone: "No owner assigned",
            ownerIdLabel: "Owner ID",
            adminAssignTitle: "Admin: assign station",
            adminAssignHelper: "Provide either a user ID or email.",
            adminAssignUserId: "User ID",
            adminAssignEmail: "Email",
            adminAssignSubmit: "Assign owner",
            adminAssignSuccess: "Station owner updated.",
            adminAssignError: "Unable to update the owner.",
            adminAssignMissingFields: "Enter a user ID or email first.",
            adminSearchTitle: "Admin: load other stations",
            adminSearchDescription: "You start with the stations you actually own. Provide an exact station ID or part of a station name to load additional stations for editing.",
            adminSearchHelper: "Station ID takes priority over the name if both fields are filled.",
            adminSearchStationId: "Station ID",
            adminSearchStationName: "Station name contains",
            adminSearchAction: "Load stations",
            adminSearchReset: "Back to my stations",
            adminSearchLoading: "Loading stations...",
            adminSearchMissing: "Enter a station ID or station name before searching.",
            adminSearchFailed: "We couldn't load stations with that filter.",
            adminSearchActiveStation: "Showing results for station ID {id}.",
            adminSearchActiveName: "Showing results for names containing \"{name}\".",
            adminPasswordTitle: "Admin: reset a user's password",
            adminPasswordUserId: "Target user ID",
            adminPasswordNewPassword: "New password",
            adminPasswordSubmit: "Set password",
            adminPasswordSuccess: "Password updated for that user.",
            adminPasswordError: "Unable to update that user's password.",
            adminPasswordHelper: "Provide a valid user ID (see ownership above) and a new password. The user will be signed out everywhere.",
            adminPasswordValidationError: "Enter a user ID and a password with at least 8 characters.",
            adminUsersTitle: "Admin: user management",
            adminUsersHelper: "Review all accounts, set new passwords, or delete inactive users.",
            adminUsersLoading: "Loading user accounts...",
            adminUsersEmpty: "No user accounts found.",
            adminUsersLoadError: "Unable to load the user accounts right now.",
            adminDeleteUser: "Delete user",
            adminDeleteConfirm: "Delete the account for {email}? Stations will be left unassigned.",
            adminDeleteSuccess: "Account deleted for {email}.",
            adminDeleteError: "Unable to delete that account.",
            adminUserNoEmail: "No email on file",
            adminUserCreatedAt: "Created: {date}",
            adminUserCreatedUnknown: "Creation date unavailable",
            adminUserStationCount: "Stations: {count}",
            adminUserPasswordPrompt: "Enter a new password for {email}:",
            adminUserPasswordSuccess: "Password updated for {email}.",
            adminUserPasswordError: "Unable to update the password for that account.",
            accountDeleteTitle: "Delete your account",
            accountDeleteDescription: "Remove your profile and unlink all stations. This cannot be undone.",
            accountDeleteAction: "Delete my account",
            accountDeleteConfirm: "Delete your Birdiary account? This cannot be undone.",
            accountDeleteSuccess: "Account deleted. You will be signed out.",
            accountDeleteError: "Unable to delete your account."
        },
        legend: {
            head: "Legend",
            description: "The symbols represent station activity from the last 24 hours (environment) and 72 hours (birds).",
            symbol: "Symbol",
            meaning: "Meaning",
            birdiaryLabel: "Birdiary",
            duisbirdLabel: "DuisBird",
            black: "No environmental data",
            green: "Environmental data",
            bird: "Environmental data and birds",
            blackBird: "Birds but no environmental data",
            inactiveNotice: "Stations without new data in the last 3 months are hidden by default.",
            showAll: "Show all stations",
            hideInactive: "Hide inactive stations"
        },
        dashboard: {
            header:  "Top 10 bird species, that were detected:"
        },
        share: {
            button: "Share observation",
            copy: "Copy link"
        },
        stations: {
            infospecies: "A video consists of several images. For one second, we store 30 images. Our species recognition algorithm analyzes every 10th image from the video. For the image the species are determined e.g. Pyrhulla pyrhulla with 70% for the first analyzed image. Then for the second one Cardinalis Cardinal with a probability of 60% and so on. At the end the highest probabilities for each species are determined and stored. So it can happen, as in this example, that a total of over 100% is displayed. \Our database has the German names for most of the German birds. If there is no German name next to the destination, this can be an indication that the bird is not normally found in Germany. Behind the German name is a link to the website of NABU, which gives more information about the bird. We have not been able to check all links. Therefore it may happen that some links do not work ",
            infocount: "Here you will find an overview of the counted birds yesterday and today. The bird with the highest determination is counted. Our algorithm cannot detect at this time if a bird is visiting the station for the second time. The bird will be counted again.\n Our database has the German names for most of the German birds. If there is no German name next to the destination, this can be an indication that the bird is not normally found in Germany. Behind the German name is a link to the website of NABU, which gives more information about the bird. We have not been able to check all links. Therefore it may happen that some links do not work ",
            infoenvironment: "The measured values are measured by a DHT humidity and temperature sensor. When the sensor is read out for the first time, it may happen that wrong values are read out. Therefore, measurements where the temperature is below -35°C are excluded",
            audio: "Audio:",
            weight: "Weight:",
            weightUnavailable: "No weight measurement available yet.",
            species: "Detected species: ",
            wait1: "The video is being processed and the species will be determined! ",
            wait2: "Please wait a brief moment and then click the refresh button.",
            noData1: "So far, no bird has been detected",
            noData2: "No environmental data has been collected yet",
            environment: "Environmental sensors",
            temperature: "Temperature in °C: ",
            pressure: "Air pressure in hPa: ",
            illuminance: "Illuminance in Lux: ",
            humidity: "Humidity in %: ",
            birdsCount: "Counted Birds:",
            yesterday: "Yesterday",
            today: "Today",
            search: "Species to search for",
            search2: "Search for birds",
            day: "Day to search for",
            notFound: "The station was not found, you will be redirected to the home screen in 5 seconds:",
            exhibitInfo: "Noticd: ",
            exhibitInfo2: "This movement was originally recorded by the station ",
            exhibitInfo3: " and serves here as an example recording.",
            button1: "1 Month",
            button2: "3 Months",
            button3: "All",
            timespan: "Specify the period from which the data is displayed",
            loadMoreMovements: "Load more recordings",
            loadPreviousMovements: "Load newer recordings",
            loadingMovements: "Loading recordings...",
            allMovementsLoaded: "All recordings are visible.",
            deleteMovement: "Delete",
            deleteMovementPending: "Deleting...",
            deleteMovementConfirm: "Delete this movement? The video and audio will be removed.",
            deleteMovementSuccess: "Movement deleted.",
            deleteMovementError: "Unable to delete the movement.",
            deleteMovementLoginRequired: "Please sign in to delete recordings from your station.",
            videoDeleted: "The video for this recording was deleted.",
            searchResultsLoaded: "Showing all movements that match your filters.",
            specialHighlightsTitle: "Highlights from your statistics",
            specialHighlightsDescription: "These curated recordings come from the special-bird list in the statistics and can reach beyond the latest 30 uploads.",
            specialHighlightsEmpty: "No highlight recordings stored yet. Run the statistics job or wait for the next update.",
            specialHighlightsUpdated: "Updated at {date}",
            descriptionTitle: "About this station"
        },

        table: {
            noBird: "No bird was detected on the video",
            species: "Species:",
            name: "German name",
            propability: "Propability",
            noBirdDay: "No bird was captured on this day",
            count: "Count",
            validation: "Validation",
            search: "Show species"
        },
        createStation: {
            title: "Create Station:",
            name: "Name of the station",
            descriptionLabel: "Station description (optional)",
            descriptionHelper: "Describe how your station is built and set up. This will be shown publicly on the station page.",
            mail: "Owner email",
            mailHelper: "Enter the station owner's email address.",
            mailOwnerHelper: "Using your account email.",
            mailRequired: "Please enter an email.",
            mailInvalid: "Enter a valid email address (name@example.com).",
            position: "Location of the station (enter the coordinates or move the marker on the map)",
            dataPrivacy: "You must agree to the privacy policy",
            finished: "The station was successfully created and has the ID:",
            senseboxCreated: "A senseBox on the openSenseMap was created.",
            senseboxNotCreated: "No senseBox has been created.",
            creating: "The station is being created",
            running: "Creating a station",
            overview: "Go to the overview",
            viewStation: "Inspect Station",
            dataPrivacyText: "I accept that the data collected here in this form and by the station will be published on our website. The mail addresses will not be published, but only used to notify you. All data can be deleted or modified upon request.",
            opensensemapText: "I agree that the environmental data (air temperature and humidity) and the location of my station will also be published on opensensemap.org. The senseBox created, shall be managed by the operators of the website wiediversistmeingarten.org.",
            download: "Start download of the image ",
            ssid: "Enter W-Lan SSID to configure WLAN automatically",
            pwd: "Enter W-Lan Password to configure WLAN automatically",
            createImage: "Create an image that can be installed directly on the SSD card.",
            creatingImage: "The image is being created. If this takes longer than 5 minutes, please try to restart the image creation several times. If after 15 minutes no image could be created, please download the image from the following link. But be aware that you then have to configure the WLAN and the station settings (station_id) yourself, please see the instructions: ",
            stationConfig: "Configuration of the stations",
            stationConfigText: "Here parameters can be set via the station, such as the W-Lan settings or the rotation of the camera. All parameters can also be set later on the station, but here a user-friendly input is enabled. The W-Lan data is sent to the server in double encrypted form and is only read out there.",
            rotation: "Here you can set the rotation for the camera. If the cable looks upwards enter 180, if to the right 90",
            time: "Time interval in minutes by which environmental data are to be measured",
            submit: "Create Station",
            numberVisualExamples: "Number of examples to be displayed on the ward and recorded by other stations.",
            type: "Type of the Station",
            typeHelper: 'There is a choice of 3 possible types. The normal station is the "Observer" type, which permanently records data. The "Test" type means that the station is not shown on the map and detections are automatically deleted. This is suitable for development purposes. The type "Exhibit" also automatically deletes the recorded videos. However, this is displayed on the map. In addition, examples of other stations can be displayed here.',
            stationSoftwareLabel: "Station software",
            stationSoftwareHelper: "Only Birdiary or DuisBird firmware is supported by the backend.",
            softwareOptions: {
                birdiary: "Birdiary",
                duisbird: "DuisBird"
            },
            deleteMinutes: "Time interval in minutes after which the recorded videos are deleted.",
            detectionThreshold: "Necessary probability from which the detections are stored by the AI.",
            detectionThresholdHelper: "Example: At 0.3, a detection is saved when the model claims with the probability of 30% that the detected bird on the video is a blue tit."        
        },
        validation: {
            send: "Send Validation",
            noBird: "No Bird in Video",
            next: "Go to next Bird",
            form: "Bird in video"
        },
        statistics: {
            infoSum: "To calculate these statistics, the species that was determined with the highest probability by the image recognition model is added up. Therefore, it can also happen that species are displayed that do not occur in German gardens.",
            infoValidation: "This statistic shows how many times a particular species has been validated. Therefore, it does not indicate how many times the bird was at the station. The number of validations also includes validations if no bird was detected on the video, but these are not shown in the view below. Feel free to try improving the stats directly by validating videos from your station. ",
            infoSpecialBirds: "Here we show you species that have actually been detected at one of our stations before. Only detections are taken where the probability of the species, output from the Ki, are above 85%. The validations are not included.",            showMore: "Zeige mehr Statistiken",
            show: "Show statistics",
            searchTitle: "Search all recorded birds",
            searchPlaceholder: "Type a German or Latin name",
            searchHelper: "Enter at least two characters to start searching.",
            searchNoResults: "No birds match your search yet.",
            searchResultCount: "{count} species match your search.",
            maxSpecies2: " videos were captured. Of these, on",
            maxSpecies3: " a bird detected.",
            the: "The ",
            place: "Place ",
            on: "On ",
            day: "day ", 
            with: "with ",
            birds: "Birds ",
            maxSpecies5: " most birds were:",
            maxValidated2: " most validated Birds:",
            noValidated: "No birds have been validated at the station yet. Validate birds to see statistics about them here!  ",
            maxDay2: " days with the most Birds:",
            maxDay3: "Most bird on this day ",
            env2: "measurements were taken",
            envRecentTitle: "Latest five extreme measurements",
            envNoData: "No valid measurements yet.",
            maxTemp: "The highest temperature measured was: ",
            minTemp: "The lowest temperature measured was: ",
            maxHum: "The highest humidity measured was: ",
            minHum: "The lowest humidity measured was: ",
            averageTemp: "The average temperature measured was: ",
            averageHum: "The average humidity measured was: ",
            measured: "Measured on ",
            time: "",
            measuredStation: "Measured at the station :",
            single: {
                maxSpecies1: "At the station already ",
                maxValidated: "Some birds have also been validated at the station, namely ",   
                maxDay: " days, the station has recorded at least one bird. ",
                specialBirds: "These particular birds visited the station:"  ,   
                env1: "Besides birds, the station has already collected a lot of environmental data. In total"
            },
            all: {
                maxSpecies1: "In total, already ",
                maxValidated: "In total, a few birds have already been validated, namely ",    
                maxDay: " days, the stations have recorded at least one bird. ",
                specialBirds: "These particular birds visited the stations:"  ,    
                env1: "Besides birds, the stations have already collected a lot of environmental data. In total"        
            },
            activeStationsTitle: "Active Stations",
            activeStationsWeek: "Last 7 days",
            activeStationsMonth: "Last 30 days",
            activeStations3Months: "Last 3 months",
            activeStationsTotal: "Total stations",
            lastFullUpdateLabel: "Last full nightly update",
            lastRealtimeUpdateLabel: "Last realtime update",
            neverUpdated: "not yet available"
        },
        movementCard:{
            capturedOn: "Bird captured on:  ",
            propability: "Propability: ",
            goMov: "Go to Movement",
            clipIndicator: "Recording {current}/{total}",
            previous: "Previous recording",
            next: "Next recording"
        }

    },
    de: {
        navbar: {
            create: "Erstelle Station",
            more:
                "Erfahre mehr über unser Projekt",
            overview: "Übersichtskarte",
            validation: "Validierung",
            statistics: "Statistiken",
            ebsw: "EBSW",
            ownStations: "Meine Stationen",
            login: "Anmelden",
            logout: "Abmelden",
            searchLabel: "Station finden",
            searchPlaceholder: "Stationen durchsuchen...",
            searchNoResults: "Keine Station passt zu deiner Suche.",
            searchLoading: "Stationen werden geladen...",
            searchError: "Stationen konnten nicht geladen werden."
        },

        map: {
            stationName: "Name der Station",
            inspect: "Beobachte Station",
            lastEnvironment: "Letzte Umweltmessung: ",
            lastMovement: "Letzter Vogel: ",
            statistics: "Zeige Statistiken",
            lastFeedStatus: "Letzer Futterstand: ",
            level: "Füllstand: "

        },
        login: {
            title: "Willkommen zurück",
            subtitle: "Melde dich an, um deine Stationen zu verwalten.",
            email: "E-Mail-Adresse",
            password: "Passwort",
            submit: "Anmelden",
            error: "Anmeldung fehlgeschlagen. Bitte prüfe deine Zugangsdaten.",
            backToMap: "Zurück zur Karte",
            registerPrompt: "Noch kein Konto?",
            registerLink: "Jetzt registrieren",
            forgotPrompt: "Passwort vergessen?",
            forgotLink: "Jetzt zurücksetzen",
            verifyPrompt: "Schon registriert, aber noch gesperrt?",
            verifyLink: "E-Mail bestätigen"
        },
        register: {
            title: "Erstelle dein Konto",
            subtitle: "Registriere dich, um Stationen zu verwalten und Benachrichtigungen zu erhalten.",
            name: "Anzeigename (optional)",
            email: "E-Mail-Adresse",
            password: "Passwort",
            confirmPassword: "Passwort bestätigen",
            submit: "Registrieren",
            success: "Konto wurde erstellt.",
            error: "Konto konnte nicht erstellt werden.",
            passwordMismatch: "Die Passwörter stimmen nicht überein.",
            backToLogin: "Zur Anmeldung",
            backToMap: "Zurück zur Karte"
        },
        passwordReset: {
            title: "Passwort zurücksetzen",
            requestSubtitle: "Fordere dir mit wenigen Klicks einen sicheren Link per E-Mail an.",
            confirmSubtitle: "Füge das Token aus der Mail ein und vergebe ein neues Passwort.",
            requestTab: "Link anfordern",
            confirmTab: "Neues Passwort",
            emailLabel: "E-Mail-Adresse",
            tokenLabel: "Reset-Token",
            newPasswordLabel: "Neues Passwort",
            requestSubmit: "E-Mail senden",
            confirmSubmit: "Passwort aktualisieren",
            requestSuccess: "Falls ein Konto existiert, haben wir dir soeben Anweisungen geschickt.",
            confirmSuccess: "Passwort aktualisiert. Du wirst gleich zu deinen Stationen geleitet...",
            requestError: "E-Mail konnte aktuell nicht verarbeitet werden.",
            confirmError: "Das Passwort konnte mit diesem Token nicht zurückgesetzt werden.",
            verificationRequired: "Bitte bestätige zuerst deine E-Mail. Du wirst gleich weitergeleitet...",
            backToLogin: "Zur Anmeldung",
            backToMap: "Zurück zur Karte"
        },
        verifyEmail: {
            title: "Bestätige deine E-Mail",
            verifySubtitle: "Füge das Token aus der Verifizierungs-Mail ein, um dein Konto zu aktivieren.",
            resendSubtitle: "Keine Mail erhalten? Fordere hier eine neue an.",
            verifyTab: "E-Mail verifizieren",
            resendTab: "Mail erneut senden",
            tokenLabel: "Verifizierungs-Token",
            emailLabel: "E-Mail-Adresse",
            verifySubmit: "E-Mail bestätigen",
            resendSubmit: "Mail senden",
            verifySuccess: "E-Mail bestätigt. Du wirst gleich zu deinen Stationen geleitet...",
            resendSuccess: "Falls dein Konto noch nicht bestätigt ist, ist eine neue Mail unterwegs.",
            verifyError: "Dieses Token konnte nicht bestätigt werden.",
            resendError: "Die Verifizierungs-Mail konnte nicht gesendet werden.",
            backToLogin: "Zur Anmeldung",
            backToMap: "Zurück zur Karte"
        },
        ownStations: {
            title: "Meine Stationen",
            subtitle: "Benenne Stationen um, lösche Aufnahmen oder entferne ganze Stationen.",
            refresh: "Aktualisieren",
            loading: "Lade deine Stationen...",
            loadError: "Die Stationen konnten nicht geladen werden.",
            empty: "Dir ist noch keine Station zugeordnet.",
            createCta: "Station anlegen",
            viewStation: "Station öffnen",
            deleteStation: "Station löschen",
            deleteConfirm: "Station {name} löschen? Alle Aufnahmen werden entfernt.",
            deleteSuccess: "Station gelöscht.",
            deleteError: "Station konnte nicht gelöscht werden.",
            stationKey: "Stationsschlüssel",
            copyKey: "Kopieren",
            keyCopied: "Stationsschlüssel kopiert.",
            keyCopyError: "Schlüssel konnte nicht kopiert werden.",
            nameLabel: "Stationsname",
            descriptionLabel: "Beschreibung der Station",
            descriptionHelper: "Beschreibe, wie deine Station aufgebaut ist. Dies wird öffentlich auf der Stationsseite angezeigt.",
            locationLat: "Breitengrad",
            locationLng: "Längengrad",
            mailAddresses: "E-Mail-Benachrichtigungen",
            mailHelper: "Mehrere Adressen durch Kommas trennen",
            mailNotifications: "Benachrichtigungen senden",
            senseboxLabel: "senseBox-ID",
            softwareLabel: "Stationssoftware",
            softwareOptions: {
                birdiary: "Birdiary",
                duisbird: "DuisBird"
            },
            typeLabel: "Stationstyp",
            advancedSettings: "Erweiterte Einstellungen (JSON)",
            advancedSettingsHelper: "Hier können Exhibit/Test-Optionen oder andere Parameter als JSON gepflegt werden.",
            saveStation: "Station speichern",
            saveSuccess: "Station aktualisiert.",
            saveError: "Station konnte nicht aktualisiert werden.",
            invalidLocation: "Breiten- und Längengrad müssen gültige Zahlen sein.",
            invalidAdvancedSettings: "Die erweiterten Einstellungen müssen gültiges JSON sein.",
            types: {
                observer: "Observer",
                test: "Test",
                exhibit: "Exhibit"
            },
            movements: "Neueste Bewegungen",
            movementDate: "Aufgenommen",
            movementSpecies: "Art",
            noSpecies: "Keine Bestimmung vorhanden",
            loadMoreMovements: "Weitere Bewegungen laden",
            loadAllMovements: "Alle Bewegungen laden",
            loadingMovements: "Bewegungen werden geladen...",
            allMovementsLoaded: "Alle Bewegungen werden angezeigt.",
            deleteMovement: "Löschen",
            deleteMovementConfirm: "Diese Bewegung löschen? Video und Audio werden entfernt.",
            deleteMovementSuccess: "Bewegung gelöscht.",
            deleteMovementError: "Bewegung konnte nicht gelöscht werden.",
            noMovements: "Noch keine Bewegungen vorhanden.",
            logbookTitle: "Logbuch (privat)",
            logbookHelper: "Nur du und Admins können diese Einträge sehen. Nutze es, um Notizen zu Wartung, Beobachtungen oder Änderungen an deiner Station festzuhalten.",
            logbookEmpty: "Noch keine Logbuch-Einträge vorhanden.",
            logbookAddLabel: "Neuer Logbuch-Eintrag",
            logbookAddSubmit: "Eintrag hinzufügen",
            logbookAddError: "Logbuch-Eintrag konnte nicht hinzugefügt werden.",
            logbookDeleteEntry: "Löschen",
            logbookDeleteError: "Logbuch-Eintrag konnte nicht gelöscht werden.",
            passwordTitle: "Passwort & Sicherheit",
            currentPassword: "Aktuelles Passwort",
            newPassword: "Neues Passwort",
            passwordAction: "Passwort aktualisieren",
            passwordSuccess: "Passwort wurde aktualisiert.",
            passwordError: "Passwort konnte nicht aktualisiert werden.",
            emailStatusVerified: "Deine E-Mail-Adresse ist bestätigt.",
            emailStatusPending: "Deine E-Mail-Adresse ist noch nicht bestätigt.",
            resendVerification: "Bestätigungs-E-Mail erneut senden",
            resendVerificationSending: "Bestätigungs-E-Mail wird gesendet...",
            resendVerificationSuccess: "Falls dein Konto noch unbestätigt ist, ist eine neue E-Mail unterwegs.",
            resendVerificationError: "Bestätigungs-E-Mail konnte nicht gesendet werden.",
            claimTitle: "Station zuordnen",
            claimSubtitle: "Verknüpfe eine bereits bestehende Station mit deinem Account. Gib dazu die Stations-ID ein.",
            claimStationId: "Stations-ID",
            claimAction: "Station meinem Account zuordnen",
            claimSuccess: "Station wurde deinem Account zugeordnet.",
            claimError: "Station konnte nicht zugeordnet werden. Bitte prüfe die ID.",
            claimMissingFields: "Bitte gib eine Stations-ID ein.",
            ownerLabel: "Besitzer",
            ownerNone: "Nicht zugewiesen",
            ownerIdLabel: "Besitzer-ID",
            adminAssignTitle: "Admin: Station zuweisen",
            adminAssignHelper: "Bitte eine Benutzer-ID oder E-Mail angeben.",
            adminAssignUserId: "Benutzer-ID",
            adminAssignEmail: "E-Mail",
            adminAssignSubmit: "Besitzer setzen",
            adminAssignSuccess: "Station wurde neu zugewiesen.",
            adminAssignError: "Zuweisung konnte nicht durchgeführt werden.",
            adminAssignMissingFields: "Bitte zuerst Benutzer-ID oder E-Mail eingeben.",
            adminSearchTitle: "Admin: weitere Stationen laden",
            adminSearchDescription: "Standardmäßig siehst du nur deine eigenen Stationen. Gib eine exakte Stations-ID oder einen Teil des Namens ein, um weitere Stationen zur Bearbeitung zu laden.",
            adminSearchHelper: "Wenn beide Felder gefüllt sind, hat die Stations-ID Vorrang.",
            adminSearchStationId: "Stations-ID",
            adminSearchStationName: "Stationsname enthält",
            adminSearchAction: "Stationen laden",
            adminSearchReset: "Zurück zu meinen Stationen",
            adminSearchLoading: "Stationen werden geladen...",
            adminSearchMissing: "Bitte gib zuerst eine Stations-ID oder einen Namen ein.",
            adminSearchFailed: "Stationen konnten mit diesem Filter nicht geladen werden.",
            adminSearchActiveStation: "Ergebnisse für die Stations-ID {id}.",
            adminSearchActiveName: "Ergebnisse für Namen mit \"{name}\".",
            adminPasswordTitle: "Admin: Passwort eines Nutzers setzen",
            adminPasswordUserId: "Ziel-Benutzer-ID",
            adminPasswordNewPassword: "Neues Passwort",
            adminPasswordSubmit: "Passwort setzen",
            adminPasswordSuccess: "Passwort für diesen Nutzer wurde aktualisiert.",
            adminPasswordError: "Passwort konnte nicht aktualisiert werden.",
            adminPasswordHelper: "Nutze dieses Formular nur als Admin. Der Nutzer wird überall abgemeldet.",
            adminPasswordValidationError: "Benutzer-ID und Passwort mit mindestens 8 Zeichen erforderlich.",
            adminUsersTitle: "Admin: Nutzerverwaltung",
            adminUsersHelper: "Alle Konten einsehen, Passwörter setzen oder Nutzer entfernen.",
            adminUsersLoading: "Lade Nutzerkonten...",
            adminUsersEmpty: "Keine Nutzerkonten gefunden.",
            adminUsersLoadError: "Nutzerkonten konnten nicht geladen werden.",
            adminDeleteUser: "Nutzer löschen",
            adminDeleteConfirm: "Konto für {email} löschen? Stationen werden nicht mehr zugeordnet.",
            adminDeleteSuccess: "Konto für {email} gelöscht.",
            adminDeleteError: "Konto konnte nicht gelöscht werden.",
            adminUserNoEmail: "Keine E-Mail hinterlegt",
            adminUserCreatedAt: "Erstellt: {date}",
            adminUserCreatedUnknown: "Erstellungsdatum unbekannt",
            adminUserStationCount: "Stationen: {count}",
            adminUserPasswordPrompt: "Neues Passwort für {email} eingeben:",
            adminUserPasswordSuccess: "Passwort für {email} aktualisiert.",
            adminUserPasswordError: "Passwort konnte für dieses Konto nicht aktualisiert werden.",
            accountDeleteTitle: "Konto löschen",
            accountDeleteDescription: "Profil löschen und alle Stationen lösen. Dieser Schritt kann nicht rückgängig gemacht werden.",
            accountDeleteAction: "Mein Konto löschen",
            accountDeleteConfirm: "Dein Birdiary-Konto löschen? Dies kann nicht rückgängig gemacht werden.",
            accountDeleteSuccess: "Konto gelöscht. Du wirst abgemeldet.",
            accountDeleteError: "Konto konnte nicht gelöscht werden."
        },
        legend: {
            head: "Legende",
            description: "Die Symbole zeigen Aktivität der letzten 24 Stunden (Umwelt) und 72 Stunden (Vögel).",
            symbol: "Symbol",
            meaning: "Bedeutung",
            birdiaryLabel: "Birdiary",
            duisbirdLabel: "DuisBird",
            black: "Keine Umweltdaten",
            green: "Umweltdaten",
            bird: "Umweltdaten und Vögel",
            blackBird: "Vögel aber keine Umweltdaten",
            inactiveNotice: "Stationen ohne neue Daten in den letzten 3 Monaten werden standardmäßig ausgeblendet.",
            showAll: "Alle Stationen anzeigen",
            hideInactive: "Inaktive Stationen ausblenden"
        },
        dashboard: {
            header:  "Top 10 Vogelarten, die an den Stationen erkannt wurden:"
        },
        share: {
            button: "Teile Beobachtung",
            copy: "Kopiere Link"
        },
        stations: {
            infospecies: "Ein Video besteht aus mehreren Bilder. Für eine Sekunde werden bei uns 30 Bilder gespeichert. Unser Artenerkennungsalgorithmus analysiert jedes 10. Bild aus dem Video. Für das Bild werden die Arten bestimmt z.B. Pyrhulla pyrhulla mit 70% für das Erste analysierte Bild. Für das zweite dann Cardinalis Cardinal mit einer Wahrscheinlichkeit von 60% usw. Am Ende werden die höchsten Wahrscheinlichkeiten für jede Art bestimmt und gespeichert. So kann es vorkommen, wie in diesem Beispiel, dass Insgesamt über 100% angezeigt werden. \n Unsere Datenbank besitzt die Deutschen Namen für die meisten deutschen Vögel. Wenn neben der Bestimmung kein Deutscher Name steht, kann dies ein Indiez dafür sein, dass der Vogel normalerweise nicht in Deutschland vorkommt. Hinter dem Deutschen Namen ist die Website vom NABU verlinkt, welche weitere Informationen über den Vogel liefert. Wir haben nicht alle Links überprüfen können. Daher kann es vorkommen, dass einige Links nicht funktionieren ",
            infocount: "Hier findet Ihr eine Übersicht über die gezählten Vögel gestern und heute. Hierbei wird jeweils der Vogel mit der höchsten Bestimmung gezählt. Unser Algorithmus kann zum jetzigen Zeitpunkt nicht erkennen, ob ein Vogel zum zweiten mal die Station besucht. Der Vogel wird erneut gezählt.\n Unsere Datenbank besitzt die Deutschen Namen für die meisten deutschen Vögel. Wenn neben der Bestimmung kein Deutscher Name steht, kann dies ein Indiez dafür sein, dass der Vogel normalerweise nicht in Deutschland vorkommt. Hinter dem Deutschen Namen ist die Website vom NABU verlinkt, welche weitere Informationen über den Vogel liefert. Wir haben nicht alle Links überprüfen können. Daher kann es vorkommen, dass einige Links nicht funktionieren ",
            infoenvironment: "Die gemssennen Werte werden von einem DHT Luftfeuchte und Temperatur Sensor gemessen. Wenn der Sensor zum ersten mal ausgelesen wird, kann es vorkommen, dass falsche Werte ausgelesen werden. Daher werden Messungen, bei denen die Temperatur unter -35°C beträgt, ausgeschlossen.",
            audio: "Audio:",
            weight: "Gewicht:",
            weightUnavailable: "Noch kein Gewicht erfasst.",
            species: "Erkannte Arten: ",
            wait1: "Das Video wird gerade verabeitet und die Art bestimmt! ",
            wait2: "Bitte warte einen kurzen Moment und klicke dann auf den Refresh Button",
            noData1: "Bisher wurde noch kein Vogel erkannt",
            noData2: "Bisher wurden noch keine Umweltdaten gesammelt",
            environment: "Umweltsensoren",
            temperature: "Temperatur in °C: ",
            humidity: "Luftfeuchte in %: ",
            pressure: "Luftdruck in hPa: ",
            illuminance: "Helligkeit in Lux: ",
            birdsCount: "Gezählte Vögel:",
            yesterday: "Gestern",
            today: "Heute",
            search: "Zu suchende Art",
            search2: "Durchsuche Vögel",
            day: "Zu suchender Tag",
            notFound: "Die Station wurde nicht gefunden, du wirst in 5 Sekunden auf die Home Seite geleitet",
            exhibitInfo: "Hinweis: ",
            exhibitInfo2: "Dieses Movement würde ursprünglich von der Station ",
            exhibitInfo3: " aufgenommen und dient hier als Beispiel-Aufnahme.",
            button1: "1 Monat",
            button2: "3 Monate",
            button3: "Alle",
            timespan: "Lege fest von welchem Zeitraum die Daten angezeigt werden: ",
            loadMoreMovements: "Weitere Aufnahmen laden",
            loadPreviousMovements: "Neuere Aufnahmen laden",
            loadingMovements: "Aufnahmen werden geladen...",
            allMovementsLoaded: "Alle Aufnahmen werden angezeigt.",
            deleteMovement: "Löschen",
            deleteMovementPending: "Löschen...",
            deleteMovementConfirm: "Diese Aufnahme löschen? Video und Audio werden entfernt.",
            deleteMovementSuccess: "Aufnahme gelöscht.",
            deleteMovementError: "Aufnahme konnte nicht gelöscht werden.",
            deleteMovementLoginRequired: "Bitte melde dich an, um Aufnahmen deiner Station zu löschen.",
            videoDeleted: "Das Video zu dieser Aufnahme wurde gelöscht.",
            searchResultsLoaded: "Alle passenden Aufnahmen werden angezeigt.",
            specialHighlightsTitle: "Highlights aus deinen Statistiken",
            specialHighlightsDescription: "Diese kuratierten Aufnahmen stammen aus der Liste besonderer Vögel in den Statistiken und gehen über die letzten 30 Aufnahmen hinaus.",
            specialHighlightsEmpty: "Noch keine Highlight-Aufnahmen gespeichert. Starte die Statistik-Berechnung oder warte auf das nächste Update.",
            specialHighlightsUpdated: "Aktualisiert am {date}",
            descriptionTitle: "Über diese Station"
        },
        table: {
            noBird: "Es wurde kein Vogel auf dem Video erkannt",
            species: "Art",
            name: "Deutscher Name",
            propability: "Wahrscheinlichkeit",
            noBirdDay: "An diesem Tag wurde kein Vogel bestimmt",
            count: "Anzahl",
            validation: "Validierung", 
            search: "Zeige Art"
        },
        createStation: {
            title: "Erstelle eine Station:",
            name: "Name der Station",
            descriptionLabel: "Beschreibung der Station (optional)",
            descriptionHelper: "Beschreibe, wie deine Station aufgebaut ist. Dies wird öffentlich auf der Stationsseite angezeigt.",
            mail: "E-Mail des Besitzers",
            mailHelper: "Gib die Besitzer-E-Mail ein.",
            mailOwnerHelper: "Wir verwenden deine Account-E-Mail.",
            mailRequired: "Bitte gib mindestens eine E-Mail-Adresse an.",
            mailInvalid: "Bitte gib eine gültige E-Mail-Adresse im Format name@example.com an.",
            position: "Standort der Station (Gib die Koordinaten ein oder bewege den Marker in der Karte)",
            dataPrivacy: "Ihr müsst der Datenschutzerklärung zustimmen",
            finished: "Die Station wurde erfolgreich erstellt und hat die ID:",
            senseboxCreated: "Eine Sensebox auf der OpenSenseMap wurde erstellt.",
            senseboxNotCreated: "Es wurde KEINE Sensebox erstellt.",
            creating: "Die Station wird gerade erstellt",
            running: "Erstellen einer Station",
            overview: "Gehe zum Überblick",
            viewStation: "Beobachte Station",
            dataPrivacyText: "Ich akzeptiere, dass die hier bei diesem Formular und durch die Station gesammelten Daten auf unserer Website veröffentlicht werden. Die Mail-Adressen werden nicht veröffentlicht, sondern nur genutzt um euch zu benachrichtigen. Alle Daten können auf Anfrage gelöscht oder geändert werden.",
            opensensemapText: "Ich stimme zu, dass die Umweltdaten (Lufttemperatur und -feuchte) und der Standort meiner Station auch auf opensensemap.org veröffentlicht werden. Die dort erstellte senseBox soll von den Betreibern der Website wiediversistmeingarten.org verwaltet werden.",
            download: "Starte Download des Images",
            ssid: "W-Lan SSID eingeben, um WLAN automatisch zu konfigurieren",
            pwd: "W-Lan Password eingeben, um WLAN automatisch zu konfigurieren",
            createImage: "Erstelle ein Image, welches direkt auf der SSD-Karte installiert werden kann",
            creatingImage: "Das Image wird gerade erstellt. Wenn dies länger als 5 Minuten dauert, versuchen Sie bitte mehrmals, die Erstellung des Images neu zu starten. Wenn nach 15 Minuten kein Image erstellt werden konnte, laden Sie bitte das Image unter folgendem Link herunter. Aber achten Sie darauf, dass Sie dann das WLAN und die Stationeinstellungen (station_id) selbst konfigurieren müssen, bitte schauen Sie dazu in die Anleitung: ",
            stationConfig: "Konfiguration der Station",
            stationConfigText: "Hier können Prameter über die Station gesetzt werden, wie z.B. die W-Lan Einstellungen oder die Rotation der Kamera. Alle Parameter können auch später auf der Station gesetzt werden, hier wird aber eine nutzerfreudliche Eingabe ermöglicht. Die W-Lan Daten werden zweifach verschlüsselt an den Server gesendet und erst dort ausgelesen.",
            rotation: "Hier kann die Rotation für die Kamera gesetzt werden. Wenn das Kabel nach oben schaut 180 eintragen, wenn nach rechts 90",
            time: "Zeitinterval in Minuten, indem Umweltdaten gemessen werden sollen",
            submit: "Erstelle Station",
            numberVisualExamples: "Anzahl an Beispielen, die auf der Station angezeigt werden sollen und von anderen Stationen aufgenommen wurden.",
            type: "Art der Station",
            typeHelper: 'Es gibt die Auswahl von 3 möglichen Arten. Die normale Station ist die Art "Observer" die dauerhaft Daten aufnimmt. Die Art "Test" bedeuted, dass die Station nicht auf der Karte angezeigt wird und Erkennungen automatisch gelöscht werden. Diese  ist für Entwicklungszwecke geeignet. Auch bei dem Typen "Exhibit" werdend die aufgenomennen Videos automatisch gelöscht. Diese wird jedoch auf der Karte angezeigt. Zusätzlich können hier Beispiele von anderen Stationen angezeigt werden.',
            stationSoftwareLabel: "Stationssoftware",
            stationSoftwareHelper: "Es werden nur Birdiary oder DuisBird unterstützt.",
            softwareOptions: {
                birdiary: "Birdiary",
                duisbird: "DuisBird"
            },
            deleteMinutes: "Zeitintervall in Minuten, nach dem die aufgenommen Videos wieder gelsöcht werden",
            detectionThreshold: "Notwendige Wahrscheinlichkeit, ab dem die Erkennungen von der KI gespeichert werden.",
            detectionThresholdHelper: "Bsp: Bei 0,3 wird ein Erkennung gespeichert, wenn das Modell behauptet mit der Wahrscheinlichkeit von 30% ist der erkannte Vogel auf dem Video eine Blaumeise."
        },
        validation: {
            send: "Sende Validierung",
            noBird: "Kein Vogel im Video",
            next: "Gehen zum nächsten Vogel",
            form: "Vogel im Video"
        },
        statistics: {
            infoSum: "Um diese Statistik zu berechnen wird jeweils die Art, welche von dem Bilderkennungsmodell mit der höchsten Wahrscheinlichkeit bestimmt wurde, aufsummiert. Daher kann es auch vorkommen, dass Arten angezeigt werden, die nicht in deutschen Gärten vorkommen.",
            infoValidation: "In dieser Statistik wird angezeigt, wie oft eine bestimmte Art validiert wurde. Daher gibt sie keine Auskunft darüber, wie oft der Vogel an der Station war. Die Anzahl der Validerungen schließt auch Validierungen mit ein, falls kein Vogel auf dem Video erkannt worden kannte, diese werden jedoch nicht in der Ansicht unten angezeigt. Probiere es gerne direkt aus, die Statistik zu verbessern, indem du Videos deiner Station validierst. ",
            infoSpecialBirds: "Hier zeigen wir dir Arten, die schon einmal an einer unserer Station tatsächlich erkannt wurden. Es werden nur Erkennungen berücksichtigt, bei denen das Bilderkennungsmodell die Vorhersage mit einer Wahrscheinlichkeit von 85% oder höher ausgibt. Die Validierungen fließen nicht mit ein.",
            showMore: "Zeige mehr Statistiken",
            show: "Zeige Statistiken",
            searchTitle: "Alle aufgezeichneten Vögel durchsuchen",
            searchPlaceholder: "Deutschen oder lateinischen Namen eingeben",
            searchHelper: "Bitte mindestens zwei Zeichen eingeben, um zu suchen.",
            searchNoResults: "Keine Vögel passen zu deiner Suche.",
            searchResultCount: "{count} Arten passen zu deiner Suche.",
            maxSpecies2: " Videos aufgenommen. Davon wurde auf ",
            maxSpecies3: " ein Vogel erkannt.",
            the: "Die ",
            place: "Platz ",
            on: "An ",
            day: "Tag ", 
            with: "mit ",
            birds: "Vögeln ",
            maxSpecies5: " meisten Vögel waren:",
            maxValidated2: " meisten validierten Vögel:",
            noValidated: "An der Station wurden noch keine Vögel validiert. Validere Vögel um hier Statistiken darüber zu sehen! ",
            maxDay2: "Tage mit den meisten Vögel:",
            maxDay3: "Meister Vogel an dem Tag  ",
            env2: "Messungen durchgeführt",
            envRecentTitle: "Die letzten fünf Extremwerte",
            envNoData: "Es liegen noch keine gültigen Messungen vor.",
            maxTemp: "Die höchste gemessene Temperatur war: ",
            minTemp: "Die niedrigste gemessene Temperatur war: ",
            maxHum: "Die höchste gemessene Luftfeuchtigkeit war: ",
            minHum: "Die niedirgste gemessene Luftfeuchtigkeit war: ",
            averageTemp: "Die durchschnittliche gemessene Temperatur ist: ",
            averageHum: "Die durchschnittliche gemessene Luftfeuchtigkeit ist: ",
            measured: "Gemessen am ",
            time: " Uhr",
            measuredStation: "Gemessen an der Station :",
            single: {
                maxSpecies1: "An der Station wurden schon " ,
                maxValidated: "An der Station wurden auch schon einige Vögel validiert und zwar ",   
                maxDay: " Tagen hat die Station mindestens einen Vogel aufgenommen. ",
                specialBirds: "Diese besonderen Vögel besuchten die Station:"  ,   
                env1: "Neben Vögeln hat die Station auch schon viele Umweltdaten gesammelt. Insgesamt wurden"
            },
            all: {
                maxSpecies1: "Insgesamt wurden schon ",
                maxValidated: "Insgesamt  wurden auch schon einige Vögel validiert und zwar ",    
                maxDay: "Tagen haben die Stationen mindestens einen Vogel aufgenommen. ",
                specialBirds: "Diese besonderen Vögel besuchten die Stationen:"  ,    
                env1: "Neben Vögeln haben die Stationen auch schon viele Umweltdaten gesammelt. Insgesamt wurden"        
            },
            activeStationsTitle: "Aktive Stationen",
            activeStationsWeek: "Letzte 7 Tage",
            activeStationsMonth: "Letzte 30 Tage",
            activeStations3Months: "Letzte 3 Monate",
            activeStationsTotal: "Stationen gesamt",
            lastFullUpdateLabel: "Letztes nächtliches Voll-Update",
            lastRealtimeUpdateLabel: "Letztes Echtzeit-Update",
            neverUpdated: "noch nicht verfügbar"
        },
        movementCard:{
            capturedOn: "Vogel aufgenommen am:  ",
            propability: "Wahrscheinlichkeit: ",
            goMov: "Zur Aufnahme",
            clipIndicator: "Aufnahme {current}/{total}",
            previous: "Vorherige Aufnahme",
            next: "Nächste Aufnahme"
        }
    }
};

export default language;
